import {createApp} from 'vue'

import App from './apps/App.vue'
import {store} from './store/index';

import {router} from './routes';


createApp(App)
    .use(store)
    .use(router)
    .mount('#mgt-gallery')


/*
TODO:
1. find out why type filters requires two clicks ✔
2. display loading indicators on facet selection ✔
3. display range selector on years ✔
4. item viewer ✔
5. gallery viewer ✔
6. video viewer ✔
7. Pagination
8. URL hashing
9. images details ✔
 */
